export default __webpack_public_path__ + "560ab3291675c1d2c6a997336f763a35.svg";